if (!customElements.get('most-searched-slider')) {
  customElements.define(
    'most-searched-slider',
    class MostSearchedSlider extends HTMLElement {
      constructor() {
        super();
        this.swiperEle = null;
        this.swiper = null;
        this.swiperSettings = {};
      }

      connectedCallback() {
        this.swiperEle = this.querySelector('.swiper');
        this.swiperSettings = JSON.parse(this.querySelector('#swiper-setting-data').innerHTML);
        this.initSlider();
      }

      initSlider() {
        if (!this.swiperEle) return;
        this.swiper = new Swiper(this.swiperEle, this.swiperSettings);
      }
    }
  );
}
